module.exports = __webpack_public_path__ + "images/icons/psp/portable-storage/electronics.svg";